// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__U8Aja","details":"Layout_details__AcrQX","block":"Layout_block__KGJtf","dataContainer":"Layout_dataContainer__8hr63"};